import http from "@/common/http.service";
const UPLOAD_URL = "profile/upload_pic";
const REMOVE_URL = "profile/remove_pic";
const ROOT_URL = "profile/";
const USER_UPDATE_URL = "profile/update";
const ADDRESS_UPDATE_URL = "profile/address/update";
const COMPANY_UPDATE_URL = "profile/update_companydata";
const BILL_UPDATE_URL = "profile/update_billdata";
const PASSWORD_UPDATE_URL = "profile/password_change";
const BILLING_HISTORY_URL = "profile/fetch_billing_details";
const UPDATE_QUOTA = "profile/updatequota";
const PIXEL_LIST_URL = "profile/list_tracking_code";
const DOMAIN_LIST_URL = "profile/getTrackingDomains";
const GENERATE_PIXEL_URL = "profile/save_tracking_code";
const DELETE_PIXEL_URL = "profile/deleteConversionPixel";
const INVOICE_URL = "profile/fetch_invoice";
const DOWNLOAD_INVOICE_URL = "profile/invoice_download";
export default {
  fetchBillingHistory(params, cb) {
    http.post(BILLING_HISTORY_URL, params).then(function (response) {
      var data = { items: response.data.data, total: response.data.total };
      cb(data);
    });
  },
  fetchDetails() {
    return http.get(ROOT_URL);
  },
  uploadProfilePic(params) {
    return http.post(UPLOAD_URL, params);
  },
  removeProfilePic(params) {
    return http.post(REMOVE_URL, params);
  },
  updateUserData(params) {
    return http.post(USER_UPDATE_URL, params);
  },
  updateAddressData(params) {
    return http.post(ADDRESS_UPDATE_URL, params);
  },
  updateCompanyData(params) {
    return http.post(COMPANY_UPDATE_URL, params);
  },
  updateBillData(params) {
    return http.post(BILL_UPDATE_URL, params);
  },
  changePassword(params) {
    return http.post(PASSWORD_UPDATE_URL, params);
  },
  updateQuota(params) {
    return http.post(UPDATE_QUOTA, params);
  },
  fetchPixelList(params, cb) {
    http.post(PIXEL_LIST_URL, params).then(function (response) {
      var data = {
        items: response.data.trackingCodes,
        total: response.data.totalCount,
      };
      cb(data);
    });
  },
  fetchDomainList(cb) {
    http.get(DOMAIN_LIST_URL).then(function (response) {
      cb(response.data.trackingDomains);
    });
  },
  generatePixel(params) {
    return http.post(GENERATE_PIXEL_URL, params);
  },
  deletePixel(params) {
    return http.post(DELETE_PIXEL_URL, params);
  },
  fetchInvoiceDetails(params) {
    return http.post(INVOICE_URL, params);
  },
  downloadInvoice(params) {
    return http.post(DOWNLOAD_INVOICE_URL, params);
  },
};
